import { render, staticRenderFns } from "./Lv2MangiaRistorante.vue?vue&type=template&id=7e839351"
import script from "./Lv2MangiaRistorante.vue?vue&type=script&lang=js"
export * from "./Lv2MangiaRistorante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports